import {BenchlingAction} from 'redux-stores/Action';

import {StarsActionType} from './StarsReduxActions';

export interface StarsState {
  storableSchemaIds: Array<string> | null;
}

export const STARS_INITIAL_STATE: StarsState = {
  storableSchemaIds: null,
};

export default function reduceStarsState(
  state: StarsState = STARS_INITIAL_STATE,
  action: BenchlingAction
): StarsState {
  switch (action.type) {
    case StarsActionType.FETCH_STARRED_STORABLE_SCHEMAS_COMPLETED:
    case StarsActionType.STAR_STORABLE_SCHEMA_COMPLETED:
    case StarsActionType.UNSTAR_STORABLE_SCHEMA_COMPLETED: {
      const {starred} = action;
      return {
        ...state,
        storableSchemaIds: starred,
      };
    }
    default:
      return state;
  }
}
